import styled from "styled-components";
import SquaresBackground from "@/components/common/SquaresBackground";
import React from "react";
import {getCssSizeValue, getHtmlFromRedactorField} from "@/utils/utils";
import Image, {formatImageCMSData} from "@/components/common/Image";
import GridContainer from "@/components/common/GridContainer";
import {BREAKPOINTS} from "@/styles/themeSettings";
import {useIsMobile} from "@/hooks/useDevice";

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	position: relative;
	padding: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)} ${getCssSizeValue(16, BREAKPOINTS.MOBILE)} ${getCssSizeValue(24, BREAKPOINTS.MOBILE)} ${getCssSizeValue(18, BREAKPOINTS.MOBILE)};
    color: ${({ theme }) => theme.colors.richBlack};
	margin-bottom: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};
    
	@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
    	margin-bottom: unset;
	}

    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
        padding: ${getCssSizeValue(40)} ${getCssSizeValue(40)} ${getCssSizeValue(16)} ${getCssSizeValue(48)};
	}
`

const Header = styled(GridContainer)`
	position: relative;
    z-index: 1;
    margin-bottom: ${getCssSizeValue(48, BREAKPOINTS.MOBILE)};

    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
        margin-bottom: ${getCssSizeValue(16)};
	}
`

const ImageAndInfoContainer = styled.div`
    z-index: 1;
    position: relative;
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
`

const StyledImage = styled(Image)`
	aspect-ratio: ${({ $aspectRatio }) => $aspectRatio};
	height: auto;
	width: 100%;

    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		width: auto;
		height: ${getCssSizeValue(130)};
	}
`

const Info = styled.div`
	padding-bottom: ${getCssSizeValue(40)};

    span[style= "text-decoration: line-through;"] {
        text-decoration: none!important;
		color: ${({ theme }) => theme.colors.chilliRed};
    }
`

function getData(src) {
	return {
		header: src?.header || '',
		info: src?.info || '',
		asset: formatImageCMSData(src?.asset || {})
	}
}

export default function SingleTile({ tile }) {
	const isMobile = useIsMobile()
	const { header, info, asset } = getData(tile)

	return (
		<Wrapper className='col-desktop-8 col-mobile-8'>
			<Header className='no-margin'>
				<div className='col-desktop-8 col-mobile-6 typo-strawford typo-strawford-117'>{header}</div>
				{isMobile && (
					<div className='col-mobile-2'>
						<StyledImage
							src={asset.url}
							alt={asset.alt}
							$aspectRatio={asset.aspectRatio}
						/>
					</div>
				)}
			</Header>
			<ImageAndInfoContainer>
				{!isMobile && (
					<StyledImage
						src={asset.url}
						alt={asset.alt}
						$aspectRatio={asset.aspectRatio}
					/>
				)}
				<Info dangerouslySetInnerHTML={getHtmlFromRedactorField(info)} className='typo-borna typo-borna-118'/>
			</ImageAndInfoContainer>
			<SquaresBackground columns={isMobile ? 8 : 14} rows={isMobile ? 5 : 4}/>
		</Wrapper>
	)
}